export const productNaSelectorWidgetEventEmitter = (
  srpEmitter,
  location: string,
  tabName: string,
  clickType: string,
  link?: string,
) => {
    const currentLocation = new URL(window.location.href)?.searchParams?.get('q');
    const keyword = currentLocation;

    const eventBody = {
      location,
      keyword,
      tabName,
      clickType,
      link: link || undefined,
    };

    srpEmitter.emit(eventBody);
};
